import { CSSProperties, ReactNode } from 'react'
import { OnboardingHeader } from '../onboarding-header'
import { OnboardingStepper } from '../onboarding-stepper'

const DASHBOARD_BG = '/CG Dashboard 1.png'

interface OnboardingLayoutProps {
	children: ReactNode
	currentStep?: number
	showStepper?: boolean
	showHeader?: boolean
	headerVariant?: 'sign-in' | 'sign-up'
}

export const OnboardingLayout = ({
	children,
	currentStep = 1,
	showStepper = true,
	showHeader = true,
	headerVariant = 'sign-up'
}: OnboardingLayoutProps) => {
	return (
		<div className="relative w-full min-h-[calc(100vh_-_var(--cg-top-banner-h,0px))] overflow-hidden flex flex-col">
			{/* Blurred dashboard background */}
			<div className="absolute inset-0 z-0">
				<img
					alt=""
					className="w-full h-full object-cover scale-105"
					src={DASHBOARD_BG}
					style={{ filter: 'blur(5px)' }}
				/>
				<div
					className="absolute inset-0"
					style={{
						background: 'rgba(86, 94, 115, 0.5)'
					}}
				/>
			</div>

			{/* The clipped layout keeps its header below the banner. */}
			{showHeader && (
				<div style={{ '--cg-top-banner-h': '0px' } as CSSProperties}>
					<OnboardingHeader variant={headerVariant} />
				</div>
			)}

			{/* Fill the space beneath the header. */}
			<div className="relative z-10 flex flex-1 flex-col items-center justify-center md:px-4 px-2 py-10">
				{children}
				{showStepper && (
					<div className="mt-6">
						<OnboardingStepper currentStep={currentStep} />
					</div>
				)}
			</div>
		</div>
	)
}
